import MembersList from "../../../pages/artist/members/List";
import MemberCreate from "../../../pages/artist/members/Create";
import MemberEdit from "../../../pages/artist/members/Edit";
import {getMemberCreateRoute, getMemberEditRoute, getMembersRoute} from "./factory/members";

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getMembersRoute(),
        component: MembersList,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getMemberCreateRoute(),
        component: MemberCreate,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getMemberEditRoute(),
        component: MemberEdit,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;